const middleWares = [];

export default middleWares;
